'use client'

import { Display, Log } from "../../lib/definitions";
import LogTableRow from "./logTableRow";
import RealTime from "../../ui/realTime";

import styles from "./page.module.css";

type Props = {
  currentLog?: Log
  logs: Log[]
}
const LogTableRows = ({ currentLog, logs }: Props) => {
  return (
    <div className={styles.tableRowContainer}>
      {currentLog && (
        <LogTableRow
          problemLevel={currentLog.problemLevel}
          problemId={currentLog.problemId}
          problemName={currentLog.problemName}
          rating={currentLog.rating}
          defense={currentLog.defense}
          status={currentLog.status}
          date={currentLog.createdAt}
          elapsedTime={
            <RealTime date={currentLog.createdAt} displayType={Display.ELAPSED_TIME} />
          }
        />
      )}
      {logs.map(({
        id,
        problemId,
        problemName,
        problemLevel,
        rating,
        defense,
        status,
        elapsedTime,
        createdAt
      }) => (
        <LogTableRow
          key={id}
          problemLevel={problemLevel}
          problemId={problemId}
          problemName={problemName}
          rating={rating}
          defense={defense}
          status={status}
          date={createdAt}
          elapsedTime={elapsedTime}
        />
      ))}
    </div>
  )
}

export default LogTableRows